// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/SF-Pro-Display-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/SF-Pro-Display-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/SF-Pro-Display-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fonts downloaded from https://github.com/nitidus/prosibum/tree/master/android/app/src/main/assets/fonts */

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  background-color: #a0a0a0 !important;
  /* min-height: 100vh !important; */
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.hide-scrollbar {
  scrollbar-width: none; /* For Firefox */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Edge */
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 300; /* Light */
  font-style: normal;
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 400; /* Regular */
  font-style: normal;
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 700; /* Bold */
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,4GAA4G;;AAE5G;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,qBAAqB,EAAE,gBAAgB;AACzC;;AAEA;EACE,aAAa,EAAE,iCAAiC;AAClD;;AAEA;EACE,6BAA6B;EAC7B,+DAAsE;EACtE,gBAAgB,EAAE,UAAU;EAC5B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAwE;EACxE,gBAAgB,EAAE,YAAY;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAqE;EACrE,gBAAgB,EAAE,SAAS;EAC3B,kBAAkB;AACpB","sourcesContent":["/* fonts downloaded from https://github.com/nitidus/prosibum/tree/master/android/app/src/main/assets/fonts */\n\nbody {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow: hidden;\n  background-color: #a0a0a0 !important;\n  /* min-height: 100vh !important; */\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.hide-scrollbar {\n  scrollbar-width: none; /* For Firefox */\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none; /* For Chrome, Safari, and Edge */\n}\n\n@font-face {\n  font-family: 'SF Pro Display';\n  src: url('./assets/fonts/SF-Pro-Display-Light.ttf') format('truetype');\n  font-weight: 300; /* Light */\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'SF Pro Display';\n  src: url('./assets/fonts/SF-Pro-Display-Regular.ttf') format('truetype');\n  font-weight: 400; /* Regular */\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'SF Pro Display';\n  src: url('./assets/fonts/SF-Pro-Display-Bold.ttf') format('truetype');\n  font-weight: 700; /* Bold */\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
